import { Link } from "react-router-dom";
import InfoLayout from "../components/landing/InfoLayout";
import LegalDoc from "../components/landing/LegalDoc";
import { FREE_PRODUCT_LIMIT, PRO_PRICE, PRO_TRIAL_DAYS } from "../plans";

const sections = [
    {
        id: "servicio",
        title: "Descripción del servicio",
        body: <>
            <p>Este documento establece los Términos y Condiciones de uso de la web app MiQRapp (en adelante, “la Plataforma”), propiedad de Franco Fenoglio, CUIT 20-41740222-6, con domicilio en Bragado, provincia de Buenos Aires, y email de contacto <a href="mailto:contacto@miqrapp.com">contacto@miqrapp.com</a>. Al registrarte o usar la Plataforma aceptás estos Términos.</p>
            <p>La Plataforma permite crear un menú o catálogo online de productos y servicios, compartirlo con un link y un código QR, y actualizarlo cuando quieras.</p>
        </>
    },
    {
        id: "cuenta",
        title: "Registro y cuenta",
        body: <>
            <p>Para crear una cuenta tenés que ser mayor de 18 años. Si la creás en nombre de un negocio, declarás que tenés autorización para hacerlo.</p>
            <p>Para usar la Plataforma tenés que crear una cuenta con tu email y una contraseña, o con tu cuenta de Google, y cargar información veraz sobre tu negocio.</p>
            <p>Sos responsable de mantener la confidencialidad de tus datos de acceso y de lo que se haga desde tu cuenta. El nombre de usuario que elegís para tu negocio forma el link de tu catálogo y no se puede cambiar después.</p>
        </>
    },
    {
        id: "planes",
        title: "Planes",
        body: <>
            <p>La Plataforma ofrece dos planes:</p>
            <ul>
                <li><strong>Gratis:</strong> catálogo con link y QR, hasta {FREE_PRODUCT_LIMIT} productos visibles, con la marca “Hecho con MiQRapp”. No requiere medio de pago.</li>
                <li><strong>Pro:</strong> {PRO_PRICE} por mes, con productos ilimitados y sin la marca de MiQRapp. Incluye {PRO_TRIAL_DAYS} días de prueba sin cargo.</li>
            </ul>
            <p>Los precios están expresados en pesos argentinos. Podemos actualizarlos: si cambia el precio de Pro, te avisamos con anticipación por email antes de que se aplique.</p>
        </>
    },
    {
        id: "pagos",
        title: "Suscripción y pagos",
        body: <>
            <p>La suscripción Pro se gestiona a través de Mercado Pago como un pago recurrente mensual. Al suscribirte aceptás también los términos de Mercado Pago. MiQRapp no recibe ni guarda los datos de tu tarjeta.</p>
            <p>Durante los {PRO_TRIAL_DAYS} días de prueba no se realiza ningún cobro. Si no cancelás antes de que termine la prueba, Mercado Pago cobra el primer mes y luego se renueva automáticamente cada mes.</p>
            <p>Fuera del derecho de arrepentimiento explicado en el punto siguiente, no se realizan reembolsos de un mes ya cobrado.</p>
        </>
    },
    {
        id: "arrepentimiento",
        title: "Derecho de arrepentimiento",
        body: <>
            <p>Según el artículo 34 de la Ley 24.240 de Defensa del Consumidor y el artículo 1110 del Código Civil y Comercial, podés revocar la contratación del plan Pro dentro de los 10 días corridos desde que te suscribiste, sin dar explicaciones y sin costo.</p>
            <p>Para hacerlo usá el <Link to="/arrepentimiento">Botón de arrepentimiento</Link>, que está en el pie de todas las páginas, o escribinos a <a href="mailto:contacto@miqrapp.com">contacto@miqrapp.com</a>. No hace falta iniciar sesión. Dentro de las 24 horas te enviamos por email un código de revocación, cancelamos la suscripción y, si ya se había hecho algún cobro, te devolvemos el importe completo por el mismo medio de pago.</p>
        </>
    },
    {
        id: "cancelacion",
        title: "Cancelación",
        body: <>
            <p>Podés cancelar la suscripción Pro en cualquier momento desde tu cuenta, con el enlace “Gestionar el pago en Mercado Pago”, o desde tu cuenta de Mercado Pago. La cancelación evita los cobros futuros. Pasados los 10 días del derecho de arrepentimiento, no implica el reembolso del mes en curso.</p>
            <p>Al cancelar, tu cuenta vuelve al plan Gratis: tus productos no se borran, pero el catálogo muestra solo los primeros {FREE_PRODUCT_LIMIT} y vuelve a llevar la marca de MiQRapp.</p>
        </>
    },
    {
        id: "contenido",
        title: "Contenido del usuario",
        body: <>
            <p>Sos el único responsable del contenido que publicás (textos, precios, imágenes y logos) y de tener los derechos para usarlo. Tu catálogo es público: cualquier persona con el link o el QR puede verlo.</p>
            <p>Nos reservamos el derecho de eliminar contenido o suspender cuentas que infrinjan estos Términos, la ley o derechos de terceros.</p>
        </>
    },
    {
        id: "propiedad",
        title: "Propiedad intelectual",
        body: <p>Todos los derechos sobre la Plataforma, su diseño y sus funcionalidades pertenecen a MiQRapp. El uso de la Plataforma no te otorga ningún derecho de propiedad sobre ella. El contenido que cargás sigue siendo tuyo.</p>
    },
    {
        id: "responsabilidad",
        title: "Disponibilidad y responsabilidad",
        body: <>
            <p>Trabajamos para que la Plataforma funcione siempre, pero puede haber interrupciones por mantenimiento o fallas de los servicios que usamos.</p>
            <p>La Plataforma y su titular no se hacen responsables por daños, pérdidas o perjuicios ocasionados por ataques externos, accesos no autorizados, virus, malware, denegación de servicio u otros eventos que afecten la seguridad de la Plataforma, siempre y cuando se hayan tomado medidas de seguridad razonables.</p>
        </>
    },
    {
        id: "baja",
        title: "Baja de la cuenta",
        body: <p>Podés pedir la baja de tu cuenta cuando quieras escribiendo a <a href="mailto:contacto@miqrapp.com">contacto@miqrapp.com</a> desde el email de tu cuenta. Si tenés Pro activo, cancelá primero la suscripción en Mercado Pago para evitar nuevos cobros.</p>
    },
    {
        id: "modificaciones",
        title: "Modificaciones",
        body: <p>Podemos modificar estos Términos. Cuando haya cambios importantes te avisamos por email o desde la Plataforma, y la fecha de última actualización de esta página va a cambiar.</p>
    },
    {
        id: "ley",
        title: "Legislación aplicable",
        body: <p>Estos Términos se rigen por las leyes de la República Argentina. Si contratás como consumidor, se aplican también las normas de defensa del consumidor, que prevalecen sobre cualquier cláusula de estos Términos que las contradiga.</p>
    }
];

const Terms = () => {
  return (
    <InfoLayout
        title="Términos y condiciones - MiQRapp"
        path="/terminos-y-condiciones"
        description="Términos y condiciones de uso de MiQRapp: planes, suscripción con Mercado Pago, cancelación y contenido."
        eyebrow="Legal"
        heading="Términos y condiciones"
        subheading="Las reglas para usar MiQRapp, explicadas de forma clara."
    >
        <LegalDoc
            updated="29 de octubre de 2026"
            sections={sections}
            related={{ to: "/politicas-de-privacidad", label: "Ver políticas de privacidad" }}
        ></LegalDoc>
    </InfoLayout>
  )
}

export default Terms
